import {
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  OnInit
} from '@angular/core';
import { HeaderItem } from './header-item';
import { HeaderItemLocation } from './header-item-location';
import { HeaderService } from './header.service';

@Directive({
    selector: '[pcpHeaderInject]',
    standalone: true
})
export class HeaderInjectDirective implements OnInit, OnDestroy {
  constructor(
    private templateRef: TemplateRef<any>,
    private header: HeaderService
  ) {}

  private id = Math.random().toString(36).substr(2, 10);

  @Input() pcpHeaderInject: HeaderItemLocation | null = null;
  @Input() priority: number | null = null;
  ngOnInit() {
    if (this.pcpHeaderInject === null) {
      throw new Error('HeaderItemLocation not set!');
    }
    this.header.addItem(
      new HeaderItem(
        this.id,
        this.templateRef,
        this.pcpHeaderInject,
        this.priority ? this.priority : 1
      )
    );
  }

  ngOnDestroy() {
    this.header.removeItem(this.id);
  }
}
